import { FC } from 'react';

import { useIntl } from 'react-intl';

import { QuestSection } from 'components/quests';
import { LoyaltyIncentivesGrid } from 'pages/loyalty/loyalty-incentives-components';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

import { LoyaltyRewardsExpiringPoints } from './loyalty-rewards-expiring-points';
import { LoyaltyRewardsRedesignList } from './loyalty-rewards-redesign-list';
import {
  ChallengeContainer,
  LoyaltyRewardsListTitle,
  LoyaltyRewardsListTitleContainer,
} from './loyalty-rewards.styled';
import { ILoyaltyRewardsViewProps as ILoyaltyRewardsContentProps } from './types';

export const LoyaltyRewardsRedesignContent: FC<ILoyaltyRewardsContentProps> = ({
  selectedReward,
  engineRewardsMap,
  refetchRewards,
  isWidget,
  setSelectedRewardIdFromWidget,
  isRefreshingRewards,
  rewardCategories,
  rewardsEvaluationMap,
  sanityRewardsMap,
  handleOnPress,
}) => {
  const formatters = useIntl();
  const { formatMessage } = formatters;

  const enableRewardPageStandAlone = Boolean(
    useFlag(LaunchDarklyFlag.ENABLE_REWARD_PAGE_STAND_ALONE)
  );
  const loyaltyListRoute = enableRewardPageStandAlone
    ? formatMessage({ id: 'routes.loyaltyHome' })
    : routes.loyaltyRewardsList;

  return (
    <LoyaltyIncentivesGrid
      selectedIncentive={selectedReward}
      refetch={refetchRewards}
      isRefreshing={isRefreshingRewards}
      goBack={loyaltyListRoute}
      engineIncentivesMap={engineRewardsMap}
      offersInCooldown={false}
      isWidget={isWidget}
      setSelectedRewardIdFromWidget={setSelectedRewardIdFromWidget}
    >
      <LoyaltyRewardsExpiringPoints />
      <ChallengeContainer>
        <QuestSection />
      </ChallengeContainer>
      <LoyaltyRewardsListTitleContainer>
        <LoyaltyRewardsListTitle>{formatMessage({ id: 'redeem' })}</LoyaltyRewardsListTitle>
      </LoyaltyRewardsListTitleContainer>
      <LoyaltyRewardsRedesignList
        handleOnPress={handleOnPress}
        rewardCategories={rewardCategories}
        engineRewardsMap={engineRewardsMap}
        rewardsEvaluationMap={rewardsEvaluationMap}
        sanityRewardsMap={sanityRewardsMap}
      ></LoyaltyRewardsRedesignList>
    </LoyaltyIncentivesGrid>
  );
};
